import Styles from "../../../../../scss/formFields.module.scss";
import IDynamicFormRow from "../../../../../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow";
import { UserStatus, SearchEmail } from "./ui";

const CheckUserStatusForm = (
  t: (key: string) => string,
  isLoading?: boolean,
  userStatus?: string,
  CreatedOn?: string,
  error?: string,
  onSearch?: Function,
  onClear?: Function
): IDynamicFormRow[] => {
  return [
    {
      label: "",
      keyName: "search_email",
      Component: SearchEmail,
      formProps: {
        isLoading: isLoading,
        userStatus: userStatus,
        onClear: onClear,
        onSearch: onSearch,
        error: error,
      },
      disabled: userStatus !== undefined,
      gridColumnOptions: {
        formCol: 12,
      },
      className: Styles.TextBoxWithAddon,
    },
    {
      label: "checkUserStatus.form.emailStaus",
      keyName: "email_status",
      Component: UserStatus,
      formProps: {
        userStatus: userStatus,
        CreatedOn: CreatedOn,
      },
      gridColumnOptions: {
        formCol: 12,
      },
    },
  ];
};

export default CheckUserStatusForm;
